export const wasPrice = (
  content?: {
    key: string
    value: { stringValue?: string; __typename: string }
  }[],
  wasPriceContentKey?: string,
) => {
  if (!content || !wasPriceContentKey) {
    return null
  }
  const contentValue = content.find(
    (contentItem) => contentItem.key === wasPriceContentKey,
  )

  const wasPrice =
    contentValue &&
    contentValue?.value.__typename === 'ProductContentStringValue' &&
    'stringValue' in contentValue.value
      ? contentValue.value.stringValue
      : null

  return wasPrice
}
